var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Modal', {
    attrs: {
      "loading": _vm.loading,
      "width": "1000",
      "title": "批量设置权限"
    },
    on: {
      "on-ok": function ($event) {
        return _vm.handleSubmit('formItem');
      }
    },
    model: {
      value: _vm.modalOpened,
      callback: function ($$v) {
        _vm.modalOpened = $$v;
      },
      expression: "modalOpened"
    }
  }, [_c('div', {
    staticClass: "permissions-context"
  }, [_c('div', {
    staticClass: "search-customer"
  }, [_c('h3', [_vm._v("搜索客户")]), _c('Input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入客户名",
      "clearable": "",
      "search": ""
    },
    on: {
      "on-change": _vm.searchCustomer
    },
    model: {
      value: _vm.searchtext,
      callback: function ($$v) {
        _vm.searchtext = $$v;
      },
      expression: "searchtext"
    }
  }), _c('div', {
    staticClass: "customer-wrapper"
  }, _vm._l(_vm.bulkCustomers, function (item) {
    return _c('div', {
      key: item._id,
      on: {
        "click": function ($event) {
          return _vm.addCustomer(item);
        }
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 0)], 1), _c('div', {
    staticClass: "choose-tot"
  }, [_c('h3', [_vm._v("已选客户")]), _c('div', {
    staticClass: "tot"
  }, [_vm._v("共" + _vm._s(_vm.choosedCustomerList.length) + "个")]), _c('div', {
    staticClass: "chooselist-wrapper"
  }, _vm._l(_vm.choosedCustomerList, function (item) {
    return _c('div', {
      key: item._id,
      staticClass: "choose-list",
      on: {
        "click": function ($event) {
          return _vm.deleteCustomer(item);
        }
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 0)]), _c('div', {
    staticClass: "permissions-set"
  }, [_c('h3', [_vm._v("设置权限")]), _c('div', {
    staticClass: "permissions-list"
  }, [_c('Form', {
    ref: "formItem",
    attrs: {
      "model": _vm.formItem,
      "rules": _vm.ruleValidate,
      "label-position": "top"
    },
    nativeOn: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('FormItem', {
    staticStyle: {
      "width": "366px"
    },
    attrs: {
      "label": "开发人员",
      "prop": "devSales"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "multiple": "",
      "placeholder": "请选择开发人员",
      "loading": _vm.devloading
    },
    model: {
      value: _vm.formItem.devSales,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "devSales", $$v);
      },
      expression: "formItem.devSales"
    }
  }, _vm._l(_vm.userList, function (option, index) {
    return _c('Option', {
      key: option._id,
      attrs: {
        "value": option._id
      }
    }, [_vm._v(_vm._s(option.name))]);
  }), 1)], 1), _c('FormItem', {
    staticStyle: {
      "width": "366px"
    },
    attrs: {
      "label": "维护人员",
      "prop": "maintainSales"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "multiple": "",
      "placeholder": "请选择维护人员",
      "loading": _vm.maintenanceloading
    },
    model: {
      value: _vm.formItem.maintainSales,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "maintainSales", $$v);
      },
      expression: "formItem.maintainSales"
    }
  }, _vm._l(_vm.userList, function (option, index) {
    return _c('Option', {
      key: option._id,
      attrs: {
        "value": option._id
      }
    }, [_vm._v(_vm._s(option.name))]);
  }), 1)], 1), _c('FormItem', {
    staticStyle: {
      "width": "366px"
    },
    attrs: {
      "label": "回款人员",
      "prop": "paybacker"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "multiple": "",
      "placeholder": "请选择维护人员",
      "loading": _vm.maintenanceloading
    },
    model: {
      value: _vm.formItem.paymentSales,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "paymentSales", $$v);
      },
      expression: "formItem.paymentSales"
    }
  }, _vm._l(_vm.userList, function (option, index) {
    return _c('Option', {
      key: option._id,
      attrs: {
        "value": option._id
      }
    }, [_vm._v(_vm._s(option.name))]);
  }), 1)], 1), _c('FormItem', {
    staticStyle: {
      "width": "366px"
    },
    attrs: {
      "label": "销售数据可见人员",
      "prop": "salesDataer"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "multiple": "",
      "placeholder": "请选择销售数据可见人员",
      "loading": _vm.maintenanceloading
    },
    model: {
      value: _vm.formItem.salesVisibleMember,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "salesVisibleMember", $$v);
      },
      expression: "formItem.salesVisibleMember"
    }
  }, _vm._l(_vm.userList, function (option, index) {
    return _c('Option', {
      key: option._id,
      attrs: {
        "value": option._id
      }
    }, [_vm._v(_vm._s(option.name))]);
  }), 1)], 1), _c('FormItem', {
    staticStyle: {
      "width": "366px"
    },
    attrs: {
      "label": "技术配方可见人员",
      "prop": "reciper"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "multiple": "",
      "placeholder": "请选择技术配方可见人员",
      "loading": _vm.maintenanceloading
    },
    model: {
      value: _vm.formItem.techVisibleMember,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "techVisibleMember", $$v);
      },
      expression: "formItem.techVisibleMember"
    }
  }, _vm._l(_vm.userList, function (option, index) {
    return _c('Option', {
      key: option._id,
      attrs: {
        "value": option._id
      }
    }, [_vm._v(_vm._s(option.name))]);
  }), 1)], 1), _c('FormItem', {
    staticStyle: {
      "width": "366px"
    },
    attrs: {
      "label": "部门",
      "prop": "department"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择部门"
    },
    model: {
      value: _vm.formItem.department,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "department", $$v);
      },
      expression: "formItem.department"
    }
  }, _vm._l(_vm.departmentList, function (item) {
    return _c('Option', {
      key: item._id,
      attrs: {
        "value": item._id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1)], 1)], 1)])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }